import { useTranslation } from '@framework/i18n';
import type { UploadProps } from 'antd';
import { Upload } from 'antd';
import React from 'react';
import { DraggerInputBody } from './DraggerInputBody';

const { Dragger } = Upload;

export interface DraggerInputProps extends Omit<UploadProps, 'children'> {
  /**
   * Permette di sovrascrivere il messaggio principale.
   * @default 'Fare click o trascinare il file in quest’area per caricarlo'
   */
  title?: React.ReactNode;
  /**
   * Permette di sovrascrivere il testo di aiuto per l'utente.
   * @default 'Formati consentiti: png, jpg, jpeg, svg'
   */
  info?: React.ReactNode;
}
/**
 * Componente con Body Personalizzato
 * che permette di caricare un file tramite drag and drop.
 *
 * @param title Permette di sovrascrivere il messaggio principale.
 * @param info Permette di sovrascrivere il testo di aiuto per l'utente.
 */
export function DraggerInput(props: DraggerInputProps) {
  const { title, info, ...uploadProps } = props;
  const { t } = useTranslation();

  return (
    <Dragger {...uploadProps}>
      <DraggerInputBody
        title={
          title ??
          t(
            'inputs.dragger-input.title',
            'Fare click o trascinare il file in quest’area per caricarlo',
          )
        }
        info={
          info ??
          t(
            'inputs.dragger-input.info',
            'Formati consentiti: {{formats}}',
            { formats: uploadProps.accept },
          )
        }
      />
    </Dragger>
  );
}
